import { render, staticRenderFns } from "./TextBlockListSettings.vue?vue&type=template&id=1ae5ffae&scoped=true"
import script from "./TextBlockListSettings.vue?vue&type=script&lang=ts"
export * from "./TextBlockListSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae5ffae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ae5ffae')) {
      api.createRecord('1ae5ffae', component.options)
    } else {
      api.reload('1ae5ffae', component.options)
    }
    module.hot.accept("./TextBlockListSettings.vue?vue&type=template&id=1ae5ffae&scoped=true", function () {
      api.rerender('1ae5ffae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/label-layout-editor/TextBlockListSettings.vue"
export default component.exports